import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  private url = environment.api+"api/country";

  constructor(private http: HttpClient) { }
  
  getDepartmentsByCountry(id:number){
    return this.http.get(this.url + "/"+id+"/department");
  }

  getTownsByDepartment(idDepartment:number, idCountry:number){
    return this.http.get(this.url + "/"+idCountry+"/department/"+idDepartment+"/town");
  }

  getCountry(){
    return this.http.get(this.url);
  }

  getCitizenship(){
    return this.http.get(this.url + "/citizenship");
  }
}
